import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ProductProps } from '@repo/ui/src/types';

export const normalize = (product: ProductProps) => {
  const imgUrl = product.mainImageUrl ?? buildImageSrc(product.images?.[0] ?? null, 300, 1, 1);
  return {
    title: product?.shortTitle || product.title,
    image: imgUrl,
  };
};
